/**
 * Возвращает дату, равную текущей минус daysAgo дней.
 * @param daysAgo Количество дней, которое нужно вычесть.
 * @returns Date объект, соответствующий дате daysAgo дней назад.
 */
function getDateByDaysAgo(daysAgo: number): Date {
  const nowTimestamp = Date.now(); // Текущий timestamp в миллисекундах
  const offsetInMs = daysAgo * 24 * 60 * 60 * 1000; // Количество миллисекунд в daysAgo
  const resultTimestamp = nowTimestamp - offsetInMs;

  return new Date(resultTimestamp);
}

export default getDateByDaysAgo;
